import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { PricePipe } from '../pipes/price.pipe';

@Directive({
  selector: '[appCurrency]',
})
export class CurrencyDirective implements AfterContentInit {
  @Input() useDecimals: boolean = true;

  private element: HTMLInputElement;

  private price = new PricePipe();

  constructor(private el: ElementRef, private control: NgControl, private changeDetectorRef: ChangeDetectorRef) {
    this.element = this.el.nativeElement;
  }

  @HostListener('input', ['$event'])
  public onKeyUp(event: InputEvent): void {
    const target = event.target as HTMLInputElement;

    // Stops formatting currency on keyup if the user starts adding a decimal value. Formatting then happens on blur
    if (target && target.value.search(/\./g) >= 0 && this.useDecimals) {
      return;
    }

    this.getFormattedValue();
  }

  @HostListener('blur')
  public onBlur(): void {
    this.getFormattedValue();
  }

  ngAfterContentInit(): void {
    this.getFormattedValue();
    this.changeDetectorRef.detectChanges();
  }

  private getFormattedValue(): void {
    const formControl: AbstractControl | null = this.control.control;
    const valueNumber = +this.element.value.replace(/[^\d\.\-]/g, '');
    if (valueNumber !== 0) {
      formControl?.setValue(this.price.formatMoney(valueNumber, this.useDecimals));
    } else {
      formControl?.setValue('');
    }
  }
}
